'use strict';

var _setup = require('./setup');

var $window = _setup.s.$window,
    $doc = _setup.s.$doc;
var grillStickyNavHeight = _setup._s.grillStickyNavHeight;


var $grillProductHero = $('.nx-grillhero');
var $carousel = $grillProductHero.find('.nx-grillhero__carousel');
var $carouselProgress = $grillProductHero.find('.nx-grillhero__progress-line');
var $carouselSlides = $carousel.find('.nx-grillhero__carousel-slide');
var $curr = $grillProductHero.find('.nx-grillhero__numbers-num.current span');
var $total = $grillProductHero.find('.nx-grillhero__numbers-num.total span');

var progressScale = function progressScale(idx) {
  return 'scale(' + (idx + 1) / $carouselSlides.length + ', 1)';
};

function initCarousel() {
  var flkty = $carousel.flickity({
    slideSelector: '.nx-grillhero__carousel-slide',
    wrapAround: false,
    pageDots: false,
    prevNextButtons: true,
    dragThreshold: Modernizr && Modernizr.touchevents ? 25 : 2,
    imagesLoaded: true,
    lazyLoad: true,
    selectedAttraction: 0.025,
    friction: 0.28
  }).data('flickity');

  flkty.on('scroll', function (p) {
    var displayNum = flkty.selectedIndex + 1;

    $carouselProgress.css({
      transform: progressScale(flkty.selectedIndex)
    });

    $curr.text('' + (displayNum >= 10 ? '' : '0') + (flkty.selectedIndex + 1));
  });

  $carouselProgress.css({
    transform: progressScale(0)
  });

  $curr.text('01');
  $total.text($carouselSlides.length >= 10 ? $carouselSlides.length : '0' + $carouselSlides.length);
}

$doc.ready(function () {
  if (!$grillProductHero.length) return;

  initCarousel();

  $grillProductHero.css({
    marginTop: grillStickyNavHeight
  });

  $window.resize(function () {
    $grillProductHero.css({
      marginTop: grillStickyNavHeight
    });
  });
});


//////////////////
// WEBPACK FOOTER
// ./_js/grill-product-hero.js
// module id = 25
// module chunks = 0